import { iconsApiRef, useApi } from '@backstage/frontend-plugin-api';

/**
 * The glyph of an action button, looked up by name in the app's icon bundle
 * (modules/icons.tsx), for BUI's `iconStart`/`iconEnd`. Sized by its wrapper
 * (`.waadoo-action-icon`, styles.css) to 1rem whatever the button's size.
 * Nothing at all when the name is not registered: a button without its icon
 * still says what it does.
 */
export function ActionIcon(props: { name: string }) {
  const icon = useApi(iconsApiRef).icon(props.name);
  if (!icon) {
    return null;
  }
  return <span className="waadoo-action-icon">{icon}</span>;
}
